import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UserFeedbackService } from 'app/services';
import { Utils } from 'app/utils';
import { UserFeedbackComponent } from 'app/components/user-feedback';

@Component({
    selector: 'user-feedback-detail',
    templateUrl: './user-feedback-detail.component.html',
    styleUrls: ['./user-feedback-detail.component.scss'],
    providers: [MessageService]
})
export class UserFeedbackDetailComponent implements OnInit {
    public feedbackId: number = 0;
    @Input()
    set _feedbackId(value: number) {
        this.feedbackId = value;
        if (this.feedbackId > 0) {
            this.getUserFeedbackDetail();
        }
    }

    @Input()
    public userFeedbackComponent!: UserFeedbackComponent;

    public userFeedbackDetail: any = {};

    public loading: boolean = false;
    public viewUserFeedbackDetail: boolean = false;

    public displayModalSuspend: boolean = false;

    constructor(
        private messageService: MessageService,
        private userFeedbackService: UserFeedbackService) { }

    ngOnInit(): void { }

    private getUserFeedbackDetail() {
        const dto = {
            FeedbackId: this.feedbackId,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.loading = true;
        this.viewUserFeedbackDetail = false;
        this.displayModalSuspend = false;

        this.userFeedbackService.getUserFeedbackDetail(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.viewUserFeedbackDetail = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.userFeedbackDetail = data;

                this.loading = false;
                this.viewUserFeedbackDetail = true;
            })
            .catch(err => {
                this.loading = false;
                this.viewUserFeedbackDetail = false;
                throw err;
            });
    }

    public closeFeedback() {
        const dto = {
            FeedbackId: this.feedbackId
        };

        this.userFeedbackService.closeFeedback(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Feedback closed successfully' });

                this.loading = false;

                this.userFeedbackComponent.visibleFeedbackDetail = false;
                this.userFeedbackComponent.getUserFeedbacks(0);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    showModalSuspend() {
        this.displayModalSuspend = !this.displayModalSuspend;
    }

    onChangedDisplayModalSuspend(value: any) {
        this.displayModalSuspend = value;
    }
}

